import { formatTitleSubscription } from "../payment/formatTitleSubscription";

export const capitalizeFirstLetter = (word: string): string => {
  const currentWord = formatTitleSubscription(word);

  return currentWord.charAt(0).toUpperCase() + currentWord.slice(1);
};
